<!--This component is designed to show the tasks in form of table view -->
<template>
  <v-card>
    <v-toolbar card dense>
      <v-icon>table_chart</v-icon>&nbsp; Tasks | Table View
      <!--      <v-list-tile-avatar>-->
      <!--        <v-icon>search</v-icon>-->
      <!--      </v-list-tile-avatar>-->
      <!--      <v-list-tile-content>-->
      <!--        <v-list-tile-sub-title>-->
      <!--          <v-text-field color="secondary" label="Search" v-model="search" xs5>-->
      <!--          </v-text-field>-->
      <!--        </v-list-tile-sub-title>-->
      <!--      </v-list-tile-content>-->
      <!--      <v-tooltip bottom>-->
      <!--        <v-btn slot="activator" flat icon @click="search = ''">-->
      <!--          <v-icon>clear</v-icon>-->
      <!--        </v-btn>-->
      <!--        <span>Clear search</span>-->
      <!--      </v-tooltip>-->
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="refresh()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
      <v-tooltip v-if="areTaskGrouped" bottom>
        <v-btn
          slot="activator"
          :loading="taskGroupingLoader || taskLoader"
          color="secondary"
          icon
          @click="areTaskGrouped = !areTaskGrouped"
        >
          <v-icon>mdi-ungroup</v-icon>
        </v-btn>
        <span>Un Group</span>
      </v-tooltip>

      <v-dialog v-else v-model="groupDialog" max-width="800px" scrollable>
        <template #activator="{ on }">
          <v-btn
            :loading="taskGroupingLoader || taskLoader"
            flat
            icon
            v-on="on"
          >
            <v-icon>mdi-group</v-icon>
          </v-btn>
        </template>
        <v-card class="task-card">
          <v-toolbar class="beez-bold" dense flat>
            Group By
            <v-spacer />
            <v-btn
              class="text-capitalize"
              flat
              icon
              style="font-size: 1.1em"
              @click="groupDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="px-3">
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-radio-group v-model="groupByField">
                  <v-layout wrap>
                    <v-flex
                      v-for="(item, i) in groupByLabels"
                      :key="i + 'groupByflex'"
                      md6
                      xs12
                    >
                      <v-card
                        :key="i + 'groupByCard'"
                        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                        class="ma-1 pa-1"
                        flat
                        style="border-radius: 10px"
                      >
                        <v-radio
                          :key="'radio' + i"
                          :label="item.label"
                          :value="item.value"
                          class="pa-1"
                          hide-details
                        />
                        <div class="body-2 ml-2">
                          {{
                            item.dimension
                              ? 'Applicable for ' +
                                  item.count +
                                  ' task(s) with key: ' +
                                  item.formKeyDesc || item.formKey
                              : 'Applicable for ' + item.count + ' task(s)'
                          }}
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout align-end justify-end>
              <v-btn
                :class="
                  $vuetify.dark
                    ? 'secondary text-capitalize'
                    : 'primary text-capitalize'
                "
                :outline="$vuetify.dark"
                flat
                style="font-size: 1.1em"
                @click="groupTask"
                >Apply
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-tooltip bottom>
        <v-btn flat icon slot="activator" @click="showColumnSelection">
          <v-icon>view_column</v-icon>
        </v-btn>
        <span>Choose Column</span>
      </v-tooltip>
      <v-dialog v-model="columnDialog" max-width="800px" scrollable>
        <v-card class="task-card">
          <v-toolbar class="beez-bold" dense flat>
            Choose columns By
            <v-spacer />
            <v-btn
              class="text-capitalize"
              flat
              icon
              style="font-size: 1.1em"
              @click="columnDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="px-3">
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex
                    v-for="(item, i) in getHeaders(!!this.groupItem)"
                    :key="i + 'columnSelectFlex'"
                    md6
                    xs12
                  >
                    <v-card
                      :key="i + 'columnSelectCard'"
                      :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                      class="ma-1 pa-1"
                      flat
                      style="border-radius: 10px"
                    >
                      <v-checkbox
                        :key="'checkbox' + i"
                        :label="item.text"
                        v-model="item.isSelected"
                        class="pa-1"
                        hide-details
                      />
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout align-end justify-end>
              <v-btn
                :class="
                  $vuetify.dark
                    ? 'secondary text-capitalize'
                    : 'primary text-capitalize'
                "
                :outline="$vuetify.dark"
                flat
                style="font-size: 1.1em"
                @click="applyColumnSelection"
                >Apply
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      v-if="areTaskGrouped"
      :headers="getHeadersWithSelection(false)"
      :items="groupByItems"
      :loading="taskLoader || taskGroupingLoader"
      :rows-per-page-items="headerPageItems"
      item-key="id"
    >
      <v-progress-linear slot="progress" color="accent" indeterminate />
      <template slot="items" slot-scope="props">
        <tr
          v-if="
            !filterObj ||
              !filterObj.hideInProgressTask ||
              !props.item.inProgress
          "
        >
          <td
            v-if="checkIfShown('label')"
            class="text-xs-left"
            @click="
              props.expanded = !props.expanded
              setGroupItem(props.item)
            "
          >
            <div class="caption pt-2">
              {{ props.item.groupName }}
            </div>
            <div class="body-1 font-weight-bold pt-2 pb-2">
              {{ getGroupByValue(props.item) }}
            </div>
          </td>
          <td
            v-if="checkIfShown('taskType')"
            class="text-xs-left"
            @click="
              props.expanded = !props.expanded
              setGroupItem(props.item)
            "
          >
            <div class="body-1 font-weight-bold ">
              <span> {{ getTaskTypeCaption(props.item) }}</span>
            </div>
          </td>
          <td
            v-if="checkIfShown('claimable')"
            class="text-xs-left"
            @click="
              props.expanded = !props.expanded
              setGroupItem(props.item)
            "
          >
            <div class="body-1 font-weight-bold ">
              <span>
                {{ props.item.claimable ? 'Un Assigned' : 'Assigned' }}</span
              >
            </div>
          </td>
          <td
            v-if="checkIfShown('noOfTasks')"
            class="text-xs-left"
            @click="
              props.expanded = !props.expanded
              setGroupItem(props.item)
            "
          >
            <div class="subheading">
              {{ props.item.noOfTasks }}
            </div>
          </td>
          <td
            class="align-center justify-center fill-height"
            v-if="checkIfShown('action')"
          >
            <v-flex
              v-if="
                taskType === 'unclaimed' ||
                  props.item.inProgress ||
                  (taskType === 'claimed' &&
                    props.item !== null &&
                    props.item.taskType !== null &&
                    getTaskType(props.item) !== 'FORM_TASK')
              "
            >
              <v-layout align-center fill-height justify-end row wrap>
                <v-flex xs6>
                  <v-tooltip bottom>
                    <v-btn
                      v-if="
                        taskType === 'claimed' &&
                          props.item !== null &&
                          props.item.taskType !== null &&
                          getTaskType(props.item) !== 'FORM_TASK'
                      "
                      slot="activator"
                      :class="
                        props.item.inProgress
                          ? 'grey text-capitalize'
                          : 'red text-capitalize'
                      "
                      :loading="props.item.inProgress"
                      flat
                      outline
                      @click.stop="
                        confirmApproveRejectAction(props.item, false)
                      "
                    >
                      Reject All
                    </v-btn>
                    <span>Reject all tasks</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs6>
                  <v-tooltip bottom>
                    <v-btn
                      v-if="
                        taskType === 'claimed' &&
                          props.item.taskType !== null &&
                          getTaskType(props.item) !== 'FORM_TASK'
                      "
                      slot="activator"
                      :class="
                        props.item.inProgress
                          ? 'grey text-capitalize'
                          : 'green text-capitalize'
                      "
                      :loading="props.item.inProgress"
                      flat
                      outline
                      @click.stop="confirmApproveRejectAction(props.item, true)"
                    >
                      Approve All
                    </v-btn>
                    <span>Approve all tasks</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    v-if="taskType === 'unclaimed' && props.item.claimable"
                    :loading="props.item.inProgress"
                    class="text-capitalize green"
                    flat
                    outline
                    @click.stop="confirmClaimAllAction(props.item)"
                  >
                    Claim All Task
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <div v-if="props.item.inProgress">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-chip small class="caption">
                          In-Progress
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </td>
        </tr>
      </template>
      <template slot="expand">
        <v-card class="ma-2">
          <task-table
            group-item
            :filter-obj="filterObj"
            :show-time="showTime"
            :task-type="taskType"
            :header-page-items="headerPageItems"
            :headers="getHeadersWithSelection(true)"
            :items="getGroupTaskItem"
            :loader="taskLoader"
            :pagination.sync="pagination"
            :search="search"
            @pagination-update="updatePagination"
            @task-refresh="refreshWithDelay"
          >
          </task-table>
        </v-card>
      </template>

      <template slot="no-data">
        <v-alert :value="true" color="success" icon="info">
          No Tasks found!
        </v-alert>
      </template>
      <template slot="no-results">
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" not found.
        </v-alert>
      </template>
    </v-data-table>
    <task-table
      v-else
      :filter-obj="filterObj"
      :task-type="taskType"
      :show-time="showTime"
      :header-page-items="headerPageItems"
      :items="taskItems"
      :headers="getHeadersWithSelection(false)"
      :pagination.sync="pagination"
      :loader="taskLoader"
      @pagination-update="updatePagination"
      @task-refresh="refreshWithDelay"
    >
    </task-table>
    <v-dialog v-model="confirmClaimDialog" max-width="500px">
      <v-card>
        <v-card-title class="body-2 beez-bold ">
          Confirm Claim All Task
        </v-card-title>
        <v-card-text class="body-2 beez-bold ">
          Confirm to claim all the grouped tasks?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="mt-2 text-capitalize"
            outline
            :loading="claimAllLoader"
            @click.stop="confirmClaimDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            flat
            class="mt-2 text-capitalize primary"
            outline
            :loading="claimAllLoader"
            @click.stop="handleClaimAllAction()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" max-width="600px">
      <v-card v-if="groupItem">
        <v-card-title align="left" class="pb-1">
          Confirm to &emsp13;
          <b>{{ confirmAction ? ' Approve ' : ' Reject ' }}</b> &emsp13; the
          &emsp13; <b>{{ groupItem.noOfTasks }}</b> &emsp13; tasks?
        </v-card-title>
        <v-textarea
          v-model="remarks"
          hint="Please enter the approver remarks (minimum of 2 characters)"
          label="Remarks"
          class="px-3"
          outline
        >
        </v-textarea>
        <file-input
          :options="attachmentOptions"
          @filepick="updateFileLink"
        ></file-input>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="mt-2 text-capitalize"
            outline
            v-if="taskType === 'claimed'"
            :loading="approveRejectLoader"
            @click.stop="confirmDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            flat
            class="mt-2 text-capitalize"
            outline
            v-if="taskType === 'claimed'"
            :loading="approveRejectLoader"
            :disabled="checkRemarks"
            @click.stop="handleApproveRejectAction()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import TaskTable from '@/components/task-lists/TaskTable'
import FileInput from '@/components/common/form-generator/FileInput'

export default {
  name: 'Tasks',
  components: { TaskTable, FileInput },
  props: {
    taskType: {
      type: String,
      default: 'claimed'
    },
    taskId: String,
    showTime: Boolean,
    isActive: Boolean,
    filterObj: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      rowsPerPage: 0,
      descending: false,
      currentPage: 0,
      sortBy: '',
      headerPageItems: [10, 25, 50],
      pagination: {
        sortBy: 'createdAt',
        descending: true,
        rowsPerPage: 10,
        totalItems: 0,
        page: 1
      },

      confirmDialog: false,
      confirmClaimDialog: false,
      confirmAction: false,
      showExpand: false,
      approveRejectLoader: false,
      claimAllLoader: false,
      tasksInProgress: false,
      taskLoader: false,

      search: '',
      formLoading: false,
      selectedTask: {},
      headers: [
        { text: 'Name', value: 'name', isSelected: true },
        { text: 'Description', value: 'description', isSelected: false },
        {
          text: 'Requested By',
          value: 'externalRequestedBy',
          isSelected: true
        },
        { text: 'Task Type', value: 'taskType', isSelected: true },
        { text: 'Created At', value: 'createdAt', isSelected: true },
        { text: 'Due date', value: 'due', isSelected: true },
        { text: 'Follow up date', value: 'followUp', isSelected: false },
        {
          text: 'Task Properties',
          value: 'dimension1',
          align: 'center',
          isSelected: true
        },
        {
          text: 'Action',
          align: 'center',
          value: 'action',
          isSelected: true,
          width: '150px'
        }
      ],
      headersGroupClaimed: [
        { text: 'Grouped by', value: 'label', isSelected: true },
        { text: 'Task Type', value: 'taskType', isSelected: true },
        { text: 'Number of Tasks', value: 'noOfTasks', isSelected: true },
        {
          text: 'Action',
          align: 'center',
          value: 'action',
          isSelected: true,
          width: '300px'
        }
      ],
      headersGroupUnClaimed: [
        { text: 'Grouped by', value: 'label', isSelected: true },
        { text: 'Assignee status', value: 'claimable', isSelected: true },
        { text: 'Number of Tasks', value: 'noOfTasks', isSelected: true },
        {
          text: 'Action',
          align: 'center',
          value: 'action',
          isSelected: true,
          width: '300px'
        }
      ],
      headersUnClaimed: [
        { text: 'Name', value: 'name', isSelected: true },
        { text: 'Description', value: 'description', isSelected: false },
        { text: 'Assigned To', value: 'assignee', isSelected: true },
        {
          text: 'Requested By',
          value: 'externalRequestedBy',
          isSelected: true
        },
        { text: 'Task Type', value: 'taskType', isSelected: true },
        { text: 'Created At', value: 'createdAt', isSelected: true },
        { text: 'Due date', value: 'due', isSelected: true },
        { text: 'Follow up date', value: 'followUp', isSelected: false },
        {
          text: 'Task Properties',
          value: 'dimension1',
          align: 'center',
          isSelected: true
        },
        {
          text: 'Action',
          align: 'center',
          value: 'action',
          isSelected: true,
          width: '100px'
        }
      ],
      areTaskGrouped: false,
      taskGroupingLoader: false,
      groupDialog: false,
      columnDialog: false,
      groupByField: null,
      groupByItems: [],
      groupItem: null,

      remarks: '',
      fileAttachments: [],
      attachmentOptions: {
        name: 'fileinput',
        acceptFormats: '',
        multiple: 'true'
      }
    }
  },
  mounted() {
    this.search = this.$route.query.search || this.taskId
    this.setTotalTaskCount()
    if (this.taskType === 'claimed') {
      this.$store.dispatch('fetchTaskGroups')
    } else if (this.taskType === 'unclaimed') {
      this.$store.dispatch('fetchTaskGroupsByGroup')
    }
    this.getAssociatedFormKey()
  },
  watch: {
    isActive() {
      if (this.isActive) this.refresh()
    },
    groupDialog() {
      if (this.groupDialog) this.setGroupByLabels()
    },
    totalAssignedTasks() {
      if (!this.areTaskGrouped) {
        this.pagination.totalItems = this.totalAssignedTasks
      }
    },
    totalGroupTasks() {
      if (!this.areTaskGrouped) {
        this.pagination.totalItems = this.totalGroupTasks
      }
    },
    totalClaimedGroupTaskItems() {
      if (this.areTaskGrouped) {
        this.pagination.totalItems = this.totalClaimedGroupTaskItems
      }
    },
    totalUnClaimedGroupTaskItems() {
      if (this.areTaskGrouped) {
        this.pagination.totalItems = this.totalUnClaimedGroupTaskItems
      }
    },
    areTaskGrouped() {
      this.setTotalTaskCount()
    },
    filterObj() {
      this.refresh()
    },
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.currentPage ||
            this.pagination.rowsPerPage !== this.rowsPerPage ||
            this.pagination.sortBy !== this.sortBy ||
            this.pagination.descending !== this.descending
          ) {
            this.currentPage = this.pagination.page
            this.rowsPerPage = this.pagination.rowsPerPage
            this.sortBy = this.pagination.sortBy
            this.descending = this.pagination.descending
            this.refresh()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    }
  },
  methods: {
    async setGroupByLabels() {
      if (this.taskType === 'claimed') {
        await this.$store.dispatch('fetchTaskGroups')
      } else if (this.taskType === 'unclaimed') {
        await this.$store.dispatch('fetchTaskGroupsByGroup')
      }
    },
    applyColumnSelection() {
      this.columnDialog = false
    },
    getHeadersWithSelection(isGroupItem) {
      return this.getHeaders(isGroupItem).filter(
        item => item.isSelected === true
      )
    },
    showColumnSelection() {
      this.columnDialog = true
    },
    setTotalTaskCount() {
      switch (this.taskType) {
        case 'claimed':
          if (this.areTaskGrouped) {
            this.pagination.totalItems = this.totalClaimedGroupTaskItems
          } else {
            this.pagination.totalItems = this.totalAssignedTasks
          }
          break
        case 'unclaimed':
          if (this.areTaskGrouped) {
            this.pagination.totalItems = this.totalUnClaimedGroupTaskItems
          } else {
            this.pagination.totalItems = this.totalGroupTasks
          }
          break
        case 'support':
          this.pagination.totalItems = this.totalOwnTasks
          break
      }
    },
    updateFileLink: function(link) {
      this.fileAttachments = link
    },
    updatePagination(paginationLocal) {
      this.pagination = paginationLocal
    },
    convertDate(date) {
      if (!date) return 'Not Set'
      return this.showTime
        ? moment(date).format('MMM Do YYYY, h:mm:ss a')
        : moment(date).format('MMM Do YYYY')
    },
    async getAssociatedFormKey() {
      let urlParams = null
      await this.$store.dispatch('fetchAssociatedFormKey', urlParams)
    },
    checkIfShown(fieldName) {
      return !!this.getHeaders(false).filter(
        item => item.value === fieldName && item.isSelected === true
      ).length
    },
    getGroupByValue(item) {
      switch (item.value) {
        case 'formKey':
          return this.associatedFormKeys[item.label]
        case 'createdAt':
        case 'due':
          return moment(item.label, 'YYYY-MM-DD')
            .utc()
            .local()
            .format('DD MMMM YYYY')
        default:
          return item.label
      }
    },
    async setGroupItem(item) {
      this.groupItem = item
      await this.fetchGroupTaskItems(1, 10)
    },
    groupTask() {
      this.groupDialog = false
      this.areTaskGrouped = true
      if (this.areTaskGrouped && this.groupByField) {
        this.getTasksItemsGrouped(this.groupByField)
      }
    },
    getTaskType(item) {
      if (item.taskType === 1) {
        return 'FORM_TASK'
      } else if (item.taskType === 0) {
        return 'APPROVAL_TASK'
      } else {
        return null
      }
    },
    getTaskTypeCaption(item) {
      if (item.taskType === 1) {
        return 'User Input Task'
      } else if (item.taskType === 0) {
        return 'Approval Task'
      } else {
        return 'Empty Task'
      }
    },
    async getTasksItemsGrouped(field) {
      this.taskGroupingLoader = true
      let labelItem = this.groupByLabels.find(i => i.value === field)
      let urlParams = ''
      if (labelItem.dimension) {
        urlParams = `dimensionName=${labelItem.dimension}&dimensionValue=${labelItem.label}`
      } else {
        urlParams = `dimensionName=${labelItem.value}`
      }
      let groupHeaders
      if (this.taskType === 'claimed') {
        groupHeaders = await this.$store.dispatch(
          'fetchTaskGroupHeaders',
          urlParams
        )
      } else if (this.taskType === 'unclaimed') {
        groupHeaders = await this.$store.dispatch(
          'fetchTaskGroupHeadersByGroup',
          urlParams
        )
      }
      let groupTaskHeaders = []
      if (groupHeaders === null || groupHeaders.length === 0) {
        this.groupByItems = []
      }
      groupHeaders.forEach((item, index) => {
        let groupTaskHeader = {}
        groupTaskHeader.id = index
        groupTaskHeader.label = item.label
        if (item.type != null) {
          groupTaskHeader.taskType = item.type
          groupTaskHeader.taskTypeCaption = this.getTaskTypeCaption(
            groupTaskHeader
          )
        }
        if (item.claimable) {
          groupTaskHeader.claimable = item.claimable
        }

        groupTaskHeader.groupName = labelItem.label
        groupTaskHeader.dimension = labelItem.dimension
        groupTaskHeader.value = labelItem.value
        groupTaskHeader.valueField = labelItem.valueField
        groupTaskHeader.noOfTasks = item.count
        groupTaskHeader.inProgress = item.in_progress
        groupTaskHeaders.push(groupTaskHeader)
        this.groupByItems = groupTaskHeaders
      })

      this.taskGroupingLoader = false
    },
    fillUrlParams: function(urlParams) {
      if (!this.groupItem) {
        throw new Error('group Item not initialized')
      }
      if (this.filterObj !== null && this.filterObj.urlString) {
        urlParams = urlParams + this.filterObj.urlString
      }
      if (this.groupItem.dimension) {
        urlParams =
          urlParams +
          `&${this.groupItem.dimension}=${this.groupItem.groupName}&${this.groupItem.valueField}=${this.groupItem.label}`
      } else {
        switch (this.groupItem.value) {
          case 'createdAt':
            if (
              this.groupItem.label !== null &&
              this.groupItem.label !== undefined &&
              moment(this.groupItem.label, 'YYYY-MM-DD') !== null &&
              moment(this.groupItem.label, 'YYYY-MM-DD') !== undefined
            ) {
              urlParams =
                urlParams +
                `&fromDate=${moment(
                  this.groupItem.label,
                  'YYYY-MM-DD'
                ).toISOString()}&toDate=${moment(
                  this.groupItem.label,
                  'YYYY-MM-DD'
                )
                  .add(1, 'd')
                  .toISOString()}`
            }
            break
          case 'due':
            if (
              this.groupItem.label !== null &&
              this.groupItem.label !== undefined &&
              moment(this.groupItem.label, 'YYYY-MM-DD') !== null &&
              moment(this.groupItem.label, 'YYYY-MM-DD') !== undefined
            ) {
              urlParams =
                urlParams +
                `&dueFrom=${moment(
                  this.groupItem.label,
                  'YYYY-MM-DD'
                ).toISOString()}&dueTill=${moment(
                  this.groupItem.label,
                  'YYYY-MM-DD'
                )
                  .add(1, 'd')
                  .toISOString()}`
            }
            break
          default:
            let value = null
            if (this.groupItem.label === undefined) {
              value = null
            } else {
              value = this.groupItem.label
            }
            urlParams = urlParams + `&${this.groupItem.value}=${value}`
            break
        }
      }
      if (this.taskType === 'claimed') {
        urlParams = urlParams + `&taskType=${this.getTaskType(this.groupItem)}`
      } else if (this.taskType === 'unclaimed') {
        urlParams = urlParams + `&claimable=${this.groupItem.claimable}`
      }
      if (this.groupItem.inProgress) {
        urlParams = urlParams + `&inProgress=true`
      } else {
        urlParams = urlParams + `&inProgress=false`
      }

      return urlParams
    },
    getHeaders(isGroupItem) {
      if (this.taskType === 'claimed') {
        if (this.areTaskGrouped && !isGroupItem) {
          return this.headersGroupClaimed
        } else {
          return this.headers
        }
      } else if (this.taskType === 'unclaimed') {
        if (this.areTaskGrouped && !isGroupItem) {
          return this.headersGroupUnClaimed
        } else {
          return this.headersUnClaimed
        }
      } else if (this.taskType === 'support') {
        return this.headersUnClaimed
      }
      return {}
    },
    async fetchGroupTaskItems(page, size) {
      this.taskLoader = true
      let urlParams
      urlParams = `page=${page}&size=${size}&sort=${this.pagination.sortBy}${
        this.pagination.descending ? ',desc' : ''
      }`
      urlParams = this.fillUrlParams(urlParams)
      try {
        if (this.taskType === 'claimed') {
          await this.$store.dispatch('fetchSetClaimedGroupTaskItems', urlParams)
        } else if (this.taskType === 'unclaimed') {
          await this.$store.dispatch(
            'fetchSetUnClaimedGroupTaskItems',
            urlParams
          )
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to Fetch the Tasks',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskLoader = false
    },
    refreshWithDelay() {
      this.refresh()
      setTimeout(() => this.refresh(), 5000)
    },
    async refresh() {
      this.taskLoader = true
      let urlParams = ''
      urlParams = `page=${this.pagination.page}`
      if (this.pagination.rowsPerPage !== -1) {
        urlParams =
          urlParams +
          `&size=${this.pagination.rowsPerPage}&sort=${this.pagination.sortBy}${
            this.pagination.descending ? ',desc' : ''
          }`
      }
      try {
        if (this.taskType === 'claimed') {
          if (this.areTaskGrouped && this.groupByField) {
            await this.getTasksItemsGrouped(this.groupByField)
            if (this.groupItem) {
              urlParams = this.fillUrlParams(urlParams)
              await this.$store.dispatch(
                'fetchSetClaimedGroupTaskItems',
                urlParams
              )
            }
          } else {
            await this.$store.dispatch('fetchClaimedTasks', urlParams)
          }
        } else if (this.taskType === 'unclaimed') {
          if (this.areTaskGrouped && this.groupByField) {
            await this.getTasksItemsGrouped(this.groupByField)
            if (this.groupItem) {
              urlParams = this.fillUrlParams(urlParams)
              await this.$store.dispatch(
                'fetchSetUnClaimedGroupTaskItems',
                urlParams
              )
            }
          } else {
            await this.$store.dispatch('fetchUnClaimedTasks', urlParams)
          }
        } else if (this.taskType === 'support') {
          await this.$store.dispatch('fetchOwnTasks', urlParams)
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to Fetch the Tasks',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskLoader = false
      this.$emit('view-mounted')
      this.$emit('refresh-kpi')
    },

    async handleRejectAllGroupTask() {
      this.approveRejectLoader = true
      await this.completeTaskListActionDirect(false)
      this.approveRejectLoader = false
      this.tasksInProgress = true
    },
    async handleApproveAllGroupTask() {
      this.approveRejectLoader = true
      await this.completeTaskListActionDirect(true)
      this.approveRejectLoader = false
      this.tasksInProgress = true
    },
    async confirmApproveRejectAction(item, approved) {
      this.groupItem = item
      this.confirmAction = approved
      this.confirmDialog = true
    },
    async confirmClaimAllAction(item) {
      this.groupItem = item
      this.confirmClaimDialog = true
    },
    async handleClaimAllAction() {
      this.claimAllLoader = true
      try {
        let urlParams = ''
        urlParams = this.fillUrlParams(urlParams)
        let taskIds = await this.$store.dispatch(
          'setAllTasksInProgress',
          urlParams
        )
        let req = {}
        req.urlParams = urlParams
        req.body = taskIds
        let response = await this.$store.dispatch('claimAllTask', req)
        await this.fetchGroupTaskItems(1, 10)
        if (response && response.length > 0) {
          for (const item of response) {
            await this.$store.dispatch('directNotification', {
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
              message: item.message,
              description: 'User Task: ' + item.taskId + ' , ' + item.message,
              type: item.status,
              hideNotification: true
            })
          }
          await this.$store.dispatch('directNotification', {
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
            message: 'Bulk request placed!',
            description:
              'Bulk request for claim task placed, Please check the notifications for individual status',
            type: 'info'
          })
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to claiming all/some of the selected group Tasks',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.confirmClaimDialog = false
      this.claimAllLoader = false
      this.refreshWithDelay()
    },
    getTotalTasks() {
      return this.taskType === 'claimed'
        ? this.totalAssignedTasks
        : this.totalGroupTasks
    },
    async handleApproveRejectAction() {
      if (this.confirmAction) {
        await this.handleApproveAllGroupTask()
      } else {
        await this.handleRejectAllGroupTask()
      }
      this.confirmDialog = false
    },
    async completeTaskListActionDirect(approved) {
      try {
        let urlParams = ''
        urlParams = this.fillUrlParams(urlParams)

        let taskIds = await this.$store.dispatch(
          'setAllTasksInProgress',
          urlParams
        )

        let body = {}
        body.remarks = this.remarks
        body.fileAttachment = this.fileAttachments
        body.approval = approved
        body.taskIds = taskIds

        this.$store
          .dispatch('completeTaskListDirect', {
            body: body,
            urlParams: urlParams
          })
          .then(response => {
            if (response && response.length > 0) {
              for (const item of response) {
                this.$store.dispatch('directNotification', {
                  timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
                  message: item.message,
                  description:
                    'User Task: ' + item.taskId + ' , ' + item.message,
                  type: item.status,
                  hideNotification: true
                })
              }
            }
          })
          .catch(e => {
            this.$store.dispatch('directNotification', {
              message:
                'Unable to complete all/some of the selected group Tasks',
              description: e.response
                ? e.response.data.message
                : 'Error unknown! Kindly retry',
              type: 'error',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          })

        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Bulk request placed!',
          description:
            'Bulk request placed, Please check the notifications for individual status',
          type: 'info'
        })
        await this.fetchGroupTaskItems(1, 10)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to complete the Task',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    }
  },
  computed: {
    ...mapState({
      claimedTasks: state => state.tasks.claimedTasks,
      unclaimedTasks: state => state.tasks.unclaimedTasks,
      taskGroups: state => state.tasks.taskGroups,
      taskGroupHeaders: state => state.tasks.taskGroupHeaders,
      totalAssignedTasks: state => state.tasks.totalAssignedTasks,
      totalGroupTasks: state => state.tasks.totalGroupTasks,
      totalOwnTasks: state => state.tasks.totalOwnTasks,
      ownTasks: state => state.tasks.ownTasks,
      comments: state => state.tasks.comments,
      taskExecution: state => state.tasks.execution,
      user: state => state.session.user,
      taskCandidateUsers: state => state.tasks.taskCandidateUsers,
      associatedFormKeys: state => state.tasks.associatedFormKeys,
      claimedGroupTaskItems: state => state.tasks.claimedGroupTaskItems,
      unClaimedGroupTaskItems: state => state.tasks.unClaimedGroupTaskItems,
      totalClaimedGroupTaskItems: state =>
        state.tasks.totalClaimedGroupTaskItems,
      totalUnClaimedGroupTaskItems: state =>
        state.tasks.totalUnClaimedGroupTaskItems
    }),
    ...mapGetters({
      can: 'can'
    }),
    checkRemarks() {
      return this.remarks.length < 2
    },
    taskItems() {
      if (this.taskType === 'claimed') {
        return this.claimedTasks
      } else if (this.taskType === 'unclaimed') {
        return this.unclaimedTasks
      } else if (this.taskType === 'support') {
        return this.ownTasks
      }
      return []
    },
    groupByLabels() {
      let labels = []
      labels = [
        //TODO Group by Task Name
        // {
        //   label: 'Task Name',
        //   value: 'name',
        //   formKey: '*',
        //   count: this.getTotalTasks()
        // },
        {
          label: 'Task Key',
          value: 'formKey',
          formKey: '*',
          count: this.getTotalTasks()
        },
        {
          label: 'Created At',
          value: 'createdAt',
          formKey: '*',
          count: this.getTotalTasks()
        },
        {
          label: 'Due At',
          value: 'due',
          formKey: '*',
          count: this.getTotalTasks()
        }
      ]
      if (
        this.taskGroups &&
        this.taskGroups.length === 4 &&
        this.associatedFormKeys
      ) {
        this.taskGroups[0].dimension1.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension1',
            valueField: 'value1',
            value: 'dimension1' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[1].dimension2.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension2',
            valueField: 'value2',
            value: 'dimension2' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[2].dimension3.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension3',
            valueField: 'value3',
            value: 'dimension3' + ':' + item.dimension + ':' + item.formKey
          })
        })
        this.taskGroups[3].dimension4.forEach(item => {
          labels.push({
            label: item.dimension,
            formKey: item.formKey,
            formKeyDesc: this.associatedFormKeys[item.formKey],
            count: item.count,
            dimension: 'dimension4',
            valueField: 'value4',
            value: 'dimension4' + ':' + item.dimension + ':' + item.formKey
          })
        })
      }

      return _.uniqBy(labels, function(e) {
        return e.value
      })
    },
    getGroupTaskItem() {
      if (this.taskType === 'claimed') {
        return this.claimedGroupTaskItems
      } else if (this.taskType === 'unclaimed') {
        return this.unClaimedGroupTaskItems
      }
      return []
    }
  }
}
</script>

<style scoped />
